const flaggedItemsCategoriesActionTypes = {
  SET_FLAGGED_ITEMS_CATEGORIES: 'SET_FLAGGED_ITEMS_CATEGORIES',
  ADD_FLAGGED_ITEM_CATEGORY: 'ADD_FLAGGED_ITEM_CATEGORY',
  UPDATE_FLAGGED_ITEM_CATEGORY: 'UPDATE_FLAGGED_ITEM_CATEGORY',
  REMOVE_FLAGGED_ITEM_CATEGORY: 'REMOVE_FLAGGED_ITEM_CATEGORY',
};
export default flaggedItemsCategoriesActionTypes;
